import LPager from './src/main'

/* istanbul ignore next */
LPager.install = function(Vue) {
  Vue.component(LPager.name, LPager)
}

export default LPager
